module.exports = __webpack_public_path__ + "static/img/150-150-V1.e33d1ad.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/loader/GIF1/150-150-V1.gif
// module id = hoLj
// module chunks = 7